import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, tap } from 'rxjs';
import { NotificationContactsService } from '../../services/notification-contacts/notification-contacts.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { QfundTransactionsService } from '../../services/qfund-transactions/qfund-transactions.service';

@Component({
    selector: 'app-qfund-discrepancy-report',
    templateUrl: './qfund-discrepancy-report.component.html',
    styleUrl: './qfund-discrepancy-report.component.css',
})
export class QfundDiscrepancyReportComponent {
    selectedCreditors: any;
    transactions!: any[];

    creditors: any[] = [];
    hasClickedSearch: boolean = false;
    startDate: Date = new Date();

    public constructor(
        private etlIngestionService: EtlIngestionService,
        private appService: AppService,
        private qfundTransactionsService: QfundTransactionsService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.etlIngestionService.getCreditors().subscribe((res: any) => {
            if (isArrayWithData(res?.Creditors)) {
                this.creditors = res.Creditors;
            }
        });
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.transactions);
    }

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
    }

    get creditorCompanyNames() {
        return this.selectedCreditors.map((i: any) => i.CreditorId).join(',');
    }

    search() {
        if (isArrayWithData(this.selectedCreditors)) {
            this.appService.isShowPageSpinner = true;

            this.qfundTransactionsService
                .getQFundDiscrepancies(this.creditorCompanyNames, this.startDate)
                .pipe(
                    tap((res: any) => {
                        if (isArrayWithData(res)) {
                            this.transactions = res;
                        }
                    }),
                    catchError(this.appService.handleError),
                    finalize(() => {
                        this.appService.isShowPageSpinner = false;
                        this.hasClickedSearch = true;
                    }),
                )
                .subscribe();
        }
    }

    manualSync(transaction: any) {
        this.qfundTransactionsService
            .manualSync(transaction.id)
            .pipe(
                tap((res: any) => {
                    setTimeout(() => {
                        this.appService.showCommonMessageDialog(
                            'Success',
                            'Manual sync is successful.',
                        );

                        this.search();
                    }, 2000);
                }),
                catchError(this.appService.handleError),
                finalize(() => {}),
            )
            .subscribe();
    }
}
